import _ from 'lodash';
import {
  MY_SERVICES__PROPERTIES_WITH_GROUPED_SERVICES,
  SCHEDULES__GROUPED_BY_PROPERTY,
  REQUIRED_SERVICES__GROUPED_BY_PROPERTY,
  RECOMMENDATIONS__GROUPED_BY_PROPERTY,
  MY_SERVICES__SHOW_SHARE_WIDGET,
  SHARE__WIDGET_PLATFORM,
  SHARE__CUSTOMER_REFERRAL,
  LTRS__GROUPED_BY_SCHEDULE,
} from '@/store/types';
import { getLtrsAttributes } from '@/helpers/ltrs';

const createInitialState = () => {
  return {};
};

export const mutations = {};

export const actions = {};

export const getters = {
  [MY_SERVICES__PROPERTIES_WITH_GROUPED_SERVICES](state, getters, rootState, rootGetters) {
    const schedulesGroupedByProperty = rootGetters[SCHEDULES__GROUPED_BY_PROPERTY];
    const ltrsGroupedBySchedule = rootGetters[LTRS__GROUPED_BY_SCHEDULE];
    const requiredServicesGroupedByProperty = rootGetters[REQUIRED_SERVICES__GROUPED_BY_PROPERTY];
    const recommendationsGroupedByProperty = rootGetters[RECOMMENDATIONS__GROUPED_BY_PROPERTY];
    const sections = _.map(rootState.properties.propertiesById, (property, property_id) => {
      const section = {
        key: `property_id:${property_id}`,
        property: {
          ...property,
        },
        data: [],
      };
      const dataWithSchedulesForProperty = _.reduce(
        schedulesGroupedByProperty[property_id],
        (result, schedule) => {
          if (
            schedule.status === 'active' ||
            schedule.status === 'pending' ||
            _.get(schedule, 'manualquote.status') === 'new' ||
            _.get(schedule, 'manualquote.status') === 'priced' ||
            (schedule.status === 'cancelled' && schedule.next_eventstatus === 'scheduled')
          ) {
            const ltrsAttributes = getLtrsAttributes(ltrsGroupedBySchedule, schedule);

            result.push({
              ...schedule,
              ...ltrsAttributes,
              // key used by SectionList for vdom diffing
              key: `schedule_id:${schedule.schedule_id}`,
            });
          }
          return result;
        },
        []
      );
      const dataWithSchedulesAndRequiredServicesForProperty = _.reduce(
        requiredServicesGroupedByProperty[property_id],
        (result, requiredService) => {
          if (requiredService.status === 'new' || requiredService.status === 'ready') {
            result.push({
              ...requiredService,
              property_id: property.property_id,
              // key used by SectionList for vdom diffing
              key: `requiredService_id:${requiredService.requiredService_id}`,
            });
          }
          return result;
        },
        dataWithSchedulesForProperty
      );
      section.data = _.reduce(
        recommendationsGroupedByProperty[property_id],
        (result, recommendation) => {
          // api sends down id as 'id' for recommendations only
          if (recommendation.status === 'new' || recommendation.status === 'ready') {
            result.push({
              ...recommendation,
              property_id: property.property_id,
              // key used by SectionList for vdom diffing
              key: `recommendation_id:${recommendation.id}`,
            });
          }
          return result;
        },
        dataWithSchedulesAndRequiredServicesForProperty
      );
      return section;
    });
    return _.orderBy(
      sections,
      [
        (section) => {
          // prioritize active properties
          return section.property.is_active;
        },
        (section) => {
          // maintain property creation order in their respective is_active t/f buckets
          return section.property.property_id;
        },
      ],
      ['desc', 'asc']
    );
  },
  [MY_SERVICES__SHOW_SHARE_WIDGET](state, getters, rootState, rootGetters) {
    return (
      rootGetters[SHARE__CUSTOMER_REFERRAL] &&
      !_.get(rootGetters[SHARE__WIDGET_PLATFORM], 'share_started') &&
      Boolean(
        _.size(
          _.filter(rootState.properties.propertiesById, ({ is_active }) => {
            return Boolean(is_active);
          })
        )
      )
    );
  },
};

export const myServices = {
  state: createInitialState,
  mutations,
  actions,
  getters,
};
